import { render } from "./GridItem.vue?vue&type=template&id=117254bf&scoped=true"
import script from "./GridItem.vue?vue&type=script&lang=js"
export * from "./GridItem.vue?vue&type=script&lang=js"

import "./GridItem.vue?vue&type=style&index=0&id=117254bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117254bf"]])

export default __exports__